module.exports = __webpack_public_path__ + "media/images/design/common/images/icon_facebook-a613096fc07bef5eb72098e52230caa0.jpg";